import React, { Component } from 'react';
import SpendingForm from '../forms/SpendingForm';
// import LogIntroForm from './LogIntroForm';
import SpendingModule from './SpendingModule';
import { generateRandomNumber, makeBEM } from '../global/utils';
import { LABELS } from '../global/constants';
import Icon from '../atoms/Icon';
import { FormReveal, RevealAnimation, Toast } from './Animations';
import { Budget } from '../models/budget';
import { GeneralObserver } from './Observer';
import BudgetCategoryFilter from './BudgetCategoryFilter';
import BudgetTimeMachine from './BudgetTimeMachine';

class BudgetModule extends Component {

	constructor(props) {
		super(props);

		this.state = {
			controller: this.props.controller ? this.props.controller : false,
			boardId: this.props.parentID,
			settings: {},
			showSettings: false,
			showNewForm: false,
			offset: 0,
		}

		this.moduleName = 'budget'
		
		this.bindFunctions();
	}
	
	bindFunctions() {
		this.reactFn = this.reactFn.bind(this);
		this.handleLogDelete = this.handleLogDelete.bind(this);

		this.showFormBtnClick = this.showFormBtnClick.bind(this);
		this.toggleSettingsForm = this.toggleSettingsForm.bind(this);
		this.editSettingsSuccess = this.editSettingsSuccess.bind(this);
		this.discardForm = this.discardForm.bind(this);

		this.filterLogsByCategory = this.filterLogsByCategory.bind(this);
		this.clearCategoryFilter = this.clearCategoryFilter.bind(this);
	}

	componentDidMount() {
		this.initialSetup();
	}

	initialSetup() {
		const ctrl = this.state.controller;
		this.observer = new GeneralObserver(this.reactFn);

		ctrl.addObserver(this.observer);
		ctrl.fetchLogs();

		this.setState({
			controller: ctrl
		});
	}

	reactFn() {
		const ctrl = this.state.controller;

		this.setState({
			controller: ctrl,
		});
	}


	getMore() {
		this.getBudgetData(true);
	}


	// 
	// Update
	// 


	editSettingsSuccess(result) {
		const ctrl = this.state.controller;
		ctrl.saveSettingsSuccess(result.settings);
	}

	// TODO: Update this method
	// to tailor it to new ways
	addAnimationAttribute(logs) {
		logs.forEach(log => {
			log.animate = true;
		});
	}

	// SpendModule calls this fn
	// Calls deleteLog
	handleLogDelete(spendingId=-1) {
		const ctrl = this.state.controller;

		if ( spendingId !== -1 ) {
			ctrl.deleteLog(spendingId);
		}
	}

	// 
	// UI fns
	//

	toggleSettingsForm() {
		this.setState({
			showSettings: !this.state.showSettings
		})
	}

	toggleFormVisibility() {
		const formShown = this.state.showNewForm;

		this.setState({
			showNewForm: !formShown
		});
	}

	showFormBtnClick() {
		this.toggleFormVisibility();
	}

	discardForm() {
		this.toggleFormVisibility();
	}
	

	// Filtering by Category fns

	filterLogsByCategory(category = false) {
		if ( !category ) {
			return false;
		}

		const ctrl = this.state.controller;
		ctrl.filterLogsByCategory(category);
	}

	clearCategoryFilter() {
		const ctrl = this.state.controller;
		ctrl.clearCategoryFilter();
	}


	// Renders dummy content while reloading
	renderDummyContent() {
		return (
			<div>
				<div className='budget__filters dummy'>
					<div className="budget-time-machine dummy">
						<div className="budget-time-machine__target-date shimmer">
						</div>

					</div>

					<div className="budget-category-filter dummy">
						<div className="budget-category-filter__inputs-wrapper">
							<div className="budget-category-filter__category-select shimmer"></div>
							<div className="budget-category-filter__clear-btn shimmer"></div>
						</div>
					</div>
				</div>
				<div className="spending dummy">
					<div className="spending__icon-and-content  spending__icon-and-content--has-category">
						<div className="spending__category-icon-wrapper shimmer"></div>
						<div className="spending__content">
							<span className="spending__amount shimmer"></span>
							<span className="spending__date shimmer"></span>
							<span className="spending__description shimmer"></span>
						</div>
					</div>
				</div>
				<div className="spending dummy">
					<div className="spending__icon-and-content  spending__icon-and-content--has-category">
						<div className="spending__category-icon-wrapper shimmer"></div>
						<div className="spending__content">
							<span className="spending__amount shimmer"></span>
							<span className="spending__date shimmer"></span>
							<span className="spending__description shimmer"></span>
						</div>
					</div>
				</div>
				<div className="spending dummy">
					<div className="spending__icon-and-content  spending__icon-and-content--has-category">
						<div className="spending__category-icon-wrapper shimmer"></div>
						<div className="spending__content">
							<span className="spending__amount shimmer"></span>
							<span className="spending__date shimmer"></span>
							<span className="spending__description shimmer"></span>
						</div>
					</div>
				</div>
			</div>
		)
	}

	// Renders Spending log
	renderLog(log={}) {
		
		return (
			<SpendingModule 
				key={log.id} 
				data={ log }
				deleteAction={this.handleLogDelete}
			></SpendingModule>
		)
	}

	// Renders tally from Budget object
	renderTally(ctrl, key) {
		return (
			<div className={ `${makeBEM(this.moduleName, 'total-wrapper')} sticky` } key={key}>
				<p className={makeBEM(this.moduleName, 'total')}>{LABELS.total}:   { ctrl.displayTally() } </p>
			</div>
		)
	}

	renderCategoryEmptyMessage() {
		return (
			<p className={ makeBEM(this.moduleName, 'empty-message') } >{LABELS.categoryEmpty}</p>
		)
	}
	
	renderNoLogsMessage() {
		return (
			<p className={ makeBEM(this.moduleName, 'empty-message') } >{LABELS.noSpendingLogs}</p>
		)
	}

	renderCategoryPercentage(percentage=0) {
		return (
			<h2 className={ `h2 ${ makeBEM(this.moduleName, 'category-percentage')} ` } > { percentage }%</h2>
		)
	}

	render() {
		const ctrl = this.state.controller;
		if ( !ctrl ) {
			return false;
		}

		const settings = ctrl ? ctrl.getSettings() : [];
		if ( !settings || settings.length === 0 ) {
			return false;
		}

		const reloading = this.props.reloading;
		
		const boardId = this.state.boardId;
		const cat = ctrl ? ctrl.getCategories() : [];
		// const showSettings = this.state.showSettings;
		const logs = ctrl.getLogs();
		const hasLogs = ctrl.hasLogs();
		const filtering = ctrl.getIsFiltering();
		
		const showCatEmptyMessage = filtering && !hasLogs;
		const catPercentage = filtering ? ctrl.getCategoryPercentage() : 0;
		const showCatPercentage = filtering && hasLogs;
		const showNoLogsMessage = !filtering && !hasLogs;
		const catFilterDisabled = !filtering && ctrl.isTimeTravelling() && !hasLogs;

		const showForm = this.state.showNewForm;
		const showFormBtnClass = `btn--icon-and-text ${makeBEM(this.moduleName, 'show-form-btn')}`;

		const currentDateRange = ctrl.getCurrentDateRange();
		const randomKey = generateRandomNumber();

		if ( reloading ) {
			return (
				<div className={ this.moduleName }>
					{ this.renderDummyContent() }
				</div>
			)
		}

	    return (
	    		<div className={ this.moduleName }>

					<div className={ `board__sticky--top ${this.moduleName}__filters` }>
						<BudgetTimeMachine 
							dateChangeFn={ctrl.timeTravel} 
							initDate={ctrl.getCurrentMonth()}
						/>

						<BudgetCategoryFilter
							categories={cat}
							filterFn={ this.filterLogsByCategory  }
							clearFn= { this.clearCategoryFilter  }
							disabled={ catFilterDisabled}
						/>
					</div>

	    			{ showCatPercentage && this.renderCategoryPercentage(catPercentage) }
					
					{
						hasLogs &&
							Object.keys(logs).map(currentKey => (
								this.renderLog(logs[currentKey])
							))	
					}

					{ showNoLogsMessage && this.renderNoLogsMessage() }

					{ showCatEmptyMessage && this.renderCategoryEmptyMessage()  }
					
					{ this.renderTally(ctrl, randomKey) }

					{/* { showSettings 
						( 
							// <FormReveal key={0}> 
								<LogIntroForm
									settings={settings.toFormObject()}
									editSuccess={this.editSettingsSuccess}
									discardForm={this.toggleSettingsForm}
								/>
							// </FormReveal> 
						)
						
						:
							&& <button onClick={ () => { this.getMore() } }>Load More</button>
					} */}

					{
						<div className="board__form-btn">
							<button
								className={ showFormBtnClass }
								onClick={ this.showFormBtnClick  }
							>
								<Icon name="plus" size="2"/>{ LABELS.newSpending } 
							</button>
						</div>
                    }
					
					{
						showForm &&
						<FormReveal key={0}> 
							<SpendingForm 
								boardId={boardId}
								categories={cat}
								discardForm={this.discardForm}
								deleteAction={this.handleLogDelete}
								controller={ctrl}
							/>
						</FormReveal>
					}

					
		    	</div>
	    );
  	}
}

export default BudgetModule;